import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../foundation/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  readonly elevated?: boolean;
  readonly padded?: boolean;
}

export function Card({
  elevated = false,
  padded = true,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        'rounded-token border border-border bg-surface',
        elevated ? 'shadow-e2' : 'shadow-e1',
        padded && 'p-4',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
  return <div className={cn('mb-3 flex items-center justify-between gap-3', className)}>{children}</div>;
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
  return <h3 className={cn('text-base font-semibold text-fg', className)}>{children}</h3>;
}
